export default "__VITE_ASSET__cp0KA9Y6__"